import {
  DeviceType,
  EnvironmentalDeviceTypes,
  OccupancyDeviceTypes,
  PulseMeterDeviceTypes,
  RoomRadarDeviceTypes,
  VolumetricWaterDeviceTypes,
  WaterDeviceTypes,
} from "@tether-web-portal/types/DeviceType";

export const deviceTypeIsEnvironmental = (deviceType: DeviceType | string = "") => {
  return EnvironmentalDeviceTypes.has(deviceType.toUpperCase() as DeviceType);
};

export const deviceTypeIsRoomRadar = (deviceType: DeviceType | string = "") => {
  return RoomRadarDeviceTypes.has(deviceType.toUpperCase() as DeviceType);
};

export const deviceTypeIsOccupancy = (deviceType: DeviceType | string = "") => {
  return OccupancyDeviceTypes.has(deviceType.toUpperCase() as DeviceType);
};

export const deviceTypeIsWater = (deviceType: DeviceType | string = "") => {
  const type = deviceType.toUpperCase() as DeviceType;
  return WaterDeviceTypes.has(type) || VolumetricWaterDeviceTypes.has(type);
};

export const deviceIsPulseMeter = (deviceType?: DeviceType | string) => {
  return PulseMeterDeviceTypes.has(deviceType as DeviceType);
};

export const deviceIsVoltDrop = (deviceType?: DeviceType | string) => {
  if (!deviceType) return false;
  const d = deviceType.toUpperCase();
  return d === DeviceType.VOLTDROP || d === DeviceType.VOLTDROP_PHASE;
};
